import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { IDetalhePublicoCheques } from "../../../../../types/api/cadastros/detalhar-publico";
import PaperDraggable from "../../../../../components/PaperDraggable";
import moment from "moment";
import { formatarValorMonetario } from "../../../../../helpers/masks";

export default function DialogDetalhe({
    open,
    data,
    handleClose
}: DialogDetalheProps) {
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
            maxWidth='md'
            fullWidth
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Detalhes cheques pré-datados</DialogTitle>
            <DialogContent>
                {
                    data.cheques &&
                    <>
                        <Typography variant="h6">Cheques em aberto</Typography>
                        <TableContainer sx={{ maxHeight: 400 }}>
                            <Table size="small" stickyHeader>
                                <TableHead>
                                    <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                                        {headers.map((item, index) => {
                                            return (
                                                <TableCell key={index} align={item.numeric ? 'right' : 'left'}>
                                                    <Typography fontWeight={'bold'} variant='subtitle2'>{item.label}</Typography>
                                                </TableCell>
                                            )
                                        })}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        data.cheques.map((row, index) => {
                                            return (
                                                <TableRow
                                                    key={index}
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                    <TableCell sx={{ paddingX: 2 }}>
                                                        {moment(row.data_entrada_cheque).format('DD/MM/YYYY')}
                                                    </TableCell>
                                                    <TableCell sx={{ paddingX: 2 }}>
                                                        {moment(row.data_vencimento).format('DD/MM/YYYY')}
                                                    </TableCell>
                                                    <TableCell sx={{ paddingX: 2 }} align="right">
                                                        {formatarValorMonetario(row.valor_cheque)}
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                }
                {
                    data.cheques_devolvidos &&
                    <>
                        <Typography variant="h6">Cheques devolvidos em aberto</Typography>
                        <TableContainer sx={{ maxHeight: 400 }}>
                            <Table size="small" stickyHeader>
                                <TableHead>
                                    <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                                        {headers.map((item, index) => {
                                            return (
                                                <TableCell key={index} align={item.numeric ? 'right' : 'left'}>
                                                    <Typography fontWeight={'bold'} variant='subtitle2'>{item.label}</Typography>
                                                </TableCell>
                                            )
                                        })}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        data.cheques_devolvidos.map((row, index) => {
                                            return (
                                                <TableRow
                                                    key={index}
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                    <TableCell sx={{ paddingX: 2 }}>
                                                        {moment(row.data_entrada_cheque).format('DD/MM/YYYY')}
                                                    </TableCell>
                                                    <TableCell sx={{ paddingX: 2 }}>
                                                        {moment(row.data_vencimento).format('DD/MM/YYYY')}
                                                    </TableCell>
                                                    <TableCell sx={{ paddingX: 2 }} align="right">
                                                        {formatarValorMonetario(row.valor_cheque)}
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                }
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={handleClose}>Fechar</Button>
            </DialogActions>
        </Dialog>
    )
}

interface DialogDetalheProps {
    open: boolean;
    data: IDetalhePublicoCheques;
    handleClose: VoidFunction;
}

const headers = [
    { label: "Data entrada" },
    { label: "Data vencimento" },
    { label: "Valor", numeric: true }
]